// ARQUIVO ATUALIZADO E CORRIGIDO
import React, { useState, useRef } from 'react';
import useClickOutside from '../../hooks/useClickOutside';

const DropdownMenu = ({ trigger, children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);
    useClickOutside(menuRef, () => setIsOpen(false));

    return (
        <div className="relative" ref={menuRef}>
            <div onClick={() => setIsOpen(p => !p)}>{trigger}</div>
            {isOpen && (
                // --- INÍCIO DA ALTERAÇÃO ---
                // Adicionado um onClick para fechar o menu ao selecionar uma opção.
                <div 
                    onClick={() => setIsOpen(false)}
                    className="absolute right-0 mt-2 min-w-full w-max bg-gray-800/90 backdrop-blur-lg border border-white/10 rounded-lg shadow-xl py-1 animate-fade-in z-50"
                >
                    {children}
                </div>
                // --- FIM DA ALTERAÇÃO ---
            )}
        </div>
    );
};

export default DropdownMenu;